// GA4 커스텀 이벤트 헬퍼. gtag.js는 public/index.html에서 로드됩니다.
// 페이지뷰(초기 + SPA 라우트 변경)는 GA4 Enhanced Measurement가 자동 처리하므로
// 여기서는 GA가 자동 수집하지 않는 전환 이벤트만 보냅니다.
// PII(이메일·이름·전화 등)는 절대 전송하지 않습니다.

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}
